module.exports = __webpack_public_path__ + "static/media/life-logo-news.a5e97496.jpg";